import { createContext, useContext } from 'react'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { useFetch } from 'src/consumer/services'
import { AppAside, AppContent, AppSidebar } from '../components/index'
import PaywallProvider from '../components/paywall/PaywallProvider'
import { BusinessProfileContext, BusinessProfileProvider } from '../context/BusinessProfileContext'
import { ThemeContext } from 'src/context/ThemeContext'
import { StyledBusinessLayout } from './styledComponents'
import BusinessFooter from '../components/footer/BusinessFooter'

export const BusinessSetupContext = createContext(null)

export default function BusinessLayout() {
  const {
    loading: secureSetupLoading,
    data: secureSetupData,
    error: secureSetupError,
  } = useFetch('/api/secure/setup', '', 'web')

  return (
    <>
      <BusinessSetupContext.Provider value={{ secureSetupData, secureSetupLoading }}>
        <BusinessProfileProvider>
          <PaywallProvider>
            <LayoutChildComponent />
          </PaywallProvider>
        </BusinessProfileProvider>
      </BusinessSetupContext.Provider>
    </>
  )
}

export const LayoutChildComponent = () => {
  const { secureSetupLoading } = useContext(BusinessSetupContext)
  const { profileContextLoading } = useContext(BusinessProfileContext)
  const { theme } = useContext(ThemeContext)

  return secureSetupLoading || profileContextLoading ? (
    <LoadingSpinner bgColor="#F5F5F599" dark />
  ) : (
    <StyledBusinessLayout>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 dark:bg-bgDark overflow-x-hidden">
        <div className="body flex-grow-1 overflow-x-hidden">
          <AppContent />
        </div>
        <BusinessFooter />
      </div>
      <AppAside />
      <SEOComponent
        title={'AUMHUM Workplace'}
        description={'Explore your AUMHUM workplace.'}
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={[]}
      />
    </StyledBusinessLayout>
  )
}
